import React from 'react'

import Box from 'ibis-design-system/lib/components/core/Box';
import Flex from 'ibis-design-system/lib/components/core/Flex';

import ServerDown from './ServerDown'
import { ServerBoxSideWays } from '../Components'

const FrontendDown = ({frontend}) => {

    if(frontend === null || frontend === undefined) return null;

    return (
        <Box>
            <Flex p="12px">
                <ServerBoxSideWays>front-end</ServerBoxSideWays>
                <ServerDown date={frontend.logDate} />
            </Flex>
        </Box>
    )
}

export default FrontendDown;